import type {Base64ObjectInput, Question} from '@cp/model';
import {questionAdminCreate} from '../../api/callable/question';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useCreateQuestion() {
  const {
    fn: createQuestion,
    loading,
    error,
  } = useFunctionWrap(
    async (
      moduleId: string,
      topic: string,
      difficulty: number,
      questionText: string,
      options: string[],
      answer: string,
      explanation: string,
      hint?: string,
      image?: Base64ObjectInput | null,
      graphJsonString?: string,
      seedQuestionId?: string,
    ): Promise<Question> =>
      questionAdminCreate({
        moduleId,
        topic,
        difficulty,
        questionText,
        options,
        answer,
        explanation,
        hint,
        image: image || undefined,
        graphJsonString,
        seedQuestionId,
      }) as Promise<Question>,
  );

  return {
    createQuestion,
    loading,
    error,
  };
}
